const joinUrl = (base, path) => {
  const safeBase = String(base || "").trim();
  const safePath = String(path || "").trim();
  if (!safeBase) return safePath;
  if (!safePath) return safeBase;
  return `${safeBase.replace(/\/+$/, "")}/${safePath.replace(/^\/+/, "")}`;
};

export const LIFELINE_QR_FALLBACK_URL =
  "https://storage.googleapis.com/curebay-nonprod-application-data/B2C%20Images/Lifeline_QR.jpg";

export const fetchLifelineQrUrl = async () => {
  try {
    const baseUrl = process.env.REACT_APP_D2C_URL || "";
    const url = joinUrl(baseUrl, "enquiryForm/v1/images/LIFELINE_QR");
    const response = await fetch(url, { method: "GET" });
    if (!response.ok) return LIFELINE_QR_FALLBACK_URL;
    const data = await response.json();
    return data?.fileUrl || LIFELINE_QR_FALLBACK_URL;
  } catch (err) {
    console.warn("Lifeline QR API failed, using fallback URL:", err);
    return LIFELINE_QR_FALLBACK_URL;
  }
};
